export enum Themes {
  GRAY = 'gray',
  BLUE = 'blue',
  OLD_BLUE = 'old-blue',
}
